export const de = {
  "alert": {
    "no_assignment_theory_found": "Es gibt keine Theorie."
  },
  "arrangement": {
    "assignments": {
      "button_title_next": "Nächste Aufgabe",
      "button_title_previous": "Vorige Aufgabe",
      "collapse": "Ergebnisse verbergen",
      "complete": {
        "submit": "Abschließen",
        "submit_text": "Alle Aufgaben sind abgeschlossen. Reiche deinen Selbsttest ein, um deine Ergebnisse anzusehen."
      },
      "expand": "Ergebnisse anzeigen",
      "legend": {
        "answer_send": "Antwort wurde eingereicht",
        "draft": "Antwort ist noch nicht fertig",
        "open_question": "Offene Aufgabe",
        "review_available": "Du kannst jetzt deine Antwort überprüfen",
        "title": "Legende"
      },
      "next": "Nächste Aufgabe",
      "previous": "Vorige Aufgabe",
      "results": "Ergebnisse",
      "self_test": {
        "begin": "Starten",
        "body": "Du kannst den Selbsttest unterbrechen. Alle gespeicherten Antworten werden behalten.",
        "introduction": "Einführung",
        "next_self_score": "Zur nächsten offenen Aufgabe",
        "result": "Ergebnis",
        "results": "Zu den Ergebnissen",
        "resume": "Weiter",
        "selfscore": {
          "multiple": "Gib dir eine Bewertung für mehrere Aufgaben anhand einer Musterantwort.",
          "single": "Gib dir eine Bewertung für eine Aufgabe anhand einer Musterantwort."
        },
        "submit": "Einreichen",
        "submit_text": "Du hast alle Aufgaben erledigt. Reiche ein, um sie zu überprüfen."
      },
      "tooltip_self_score": "Selbstbewertungsaufgabe"
    },
    "block": {
      "exercises": "Aufgaben",
      "score": "Ergebnis"
    },
    "overview": {
      "button": {
        "continue": "Weiter",
        "results": "Ansehen",
        "show": {
          "results": "Ergebnisse anzeigen"
        },
        "start": "Starten"
      },
      "label": {
        "start": "Fang mit deinem Unterrichtsmaterial an"
      }
    },
    "references": "Referenzen",
    "tab": {
      "assignments": "Aufgaben",
      "contents": "Kursmaterial",
      "exercises": "Aufgaben",
      "sources": "Ressourcen",
      "terms": "Begriffe",
      "theory": "Theorie"
    }
  },
  "assignment": {
    "action": {
      "correct": "Gut gemacht! Diese Antwort ist richtig.",
      "incorrect": "Das ist nicht die richtige Antwort.",
      "missed": "Diese Antwort ist richtig, aber du hast sie nicht ausgewählt.",
      "predefined": "Diese Antwort wurde bereits für dich ausgefüllt und ist richtig."
    },
    "actions": {
      "close": "Schließen",
      "primary": {
        "check": "Prüfen",
        "complete": "Aufgabe erledigt",
        "save": "Speichern",
        "save_edited": "Modifizierte Antwort speichern",
        "submit": "Einreichen"
      }
    },
    "feedback": {
      "deleted_result": "Dein Lehrer hat die Antwort gelöscht, damit du die Aufgabe erneut machen kannst.",
      "deleted_sequence_result": "Dein Lehrer hat die Antworten des Selbsttests gelöscht, damit du die Aufgaben erneut machen kannst.",
      "reset_score": "Dein Lehrer hat die Antwort gelöscht, damit du die Aufgabe erneut machen kannst.",
      "teacher_message": "Nachricht von deinem Lehrer"
    },
    "loading": "Die Aufgabe wird geladen...",
    "question": {
      "result": {
        "actions": {
          "check_results": "Ergebnisse ansehen",
          "hide_answer": "Antwort ausblenden",
          "next_question": "Nächste Aufgabe",
          "show_answer": "Antwort anzeigen"
        },
        "check_results": "Du kannst jetzt die Ergebnisse ansehen.",
        "info": {
          "hide_answer": "Blende die Antwort aus, um die Aufgabe zu machen."
        },
        "next_question": "Gehe zur nächsten Aufgabe.",
        "primary": {
          "check": "Mach die oben stehende Aufgabe. Wenn du fertig bist, kannst du deine Antwort überprüfen.",
          "complete": "Führe die obenstehende Aufgabe aus. Du kannst abschließen, sobald du die Aufgabe erledigt hast.",
          "submit": "Mach die oben stehende Aufgabe. Du kannst deine Antwort einreichen, wenn du fertig bist."
        },
        "review_disabled": "Die Überprüfung deiner Antwort wurde deaktiviert. Wenn du dich selbst bewerten möchtest, bitte deinen Lehrer, die Überprüfung wieder zu aktivieren.",
        "self_score": {
          "actions": {
            "confirm_score": "Punktzahl bestätigen"
          },
          "check_answer_and_score": "Gut gemacht! Überprüfe deine Antwort und gib dir oben eine Punktzahl.",
          "confirm_score": "Gut gemacht, du kannst jetzt deine Punktzahl bestätigen."
        },
        "statuses": {
          "checked": {
            "actions": {
              "show_answer": "Antwort anzeigen",
              "show_answer_info": "Kommst du nicht weiter? Du kannst die richtigen Antworten ansehen. Deine aktuelle Punktzahl von {{score}}% kann nicht mehr verbessert werden.",
              "try_again": "Versuche es noch einmal",
              "try_again_info": "(1)[erster Versuch];(2)[zweiter Versuch];(3)[dritter Versuch];(4)[vierter Versuch];(5)[fünfter Versuch];(6)[sechster Versuch];(7)[siebter Versuch];(8)[achter Versuch];(9)[neunter Versuch];(10)[zehnter Versuch];(11-inf)[Versuch {{count}}]"
            },
            "max_score": "Gut gemacht! Du hast diese Aufgabe abgeschlossen.",
            "try_again": "Hmm, deine Antwort war nicht ganz richtig. Versuch es noch einmal."
          },
          "completed": {
            "attempt": "(1)[Punktzahl nach dem ersten Versuch];(2)[Punktzahl nach dem zweiten Versuch];(3)[Punktzahl nach dem dritten Versuch];(4)[Punktzahl nach dem vierten Versuch];(5)[Punktzahl nach dem fünften Versuch];(6)[Punktzahl nach dem sechsten Versuch];(7)[Punktzahl nach dem siebten Versuch];(8)[Punktzahl nach dem achten Versuch];(9)[Punktzahl nach dem neunten Versuch];(10)[Punktzahl nach dem zehnten Versuch];(11-inf)[Punktzahl nach dem Versuch {{count}}]",
            "default_one": "Deine Punktzahl für diese Aufgabe ist {{score}}% nach {{count}} Versuch.",
            "default_other": "Deine Punktzahl für diese Aufgabe ist {{score}}% nach {{count}} Versuchen.",
            "default_zero": "Deine Punktzahl für diese Aufgabe ist {{score}}% nach {{count}} Versuchen.",
            "done": "Du hast diese Aufgabe erledigt.",
            "message": "Gut gemacht! Du hast diese Aufgabe abgeschlossen.",
            "message_closed": "Antwort angezeigt",
            "score": "Ergebnis",
            "self_score": "Deine Punktzahl für diese Aufgabe ist {{score}}%."
          },
          "submitted": {
            "actions": {
              "duplicate_value": "Diese Antwort ist die gleiche wie eine zuvor gegebene Antwort.",
              "try_again_info": "Die Antwort ist gespeichert. Du kannst deine Antwort noch anpassen."
            }
          }
        },
        "validation": {
          "invalid": "Deine Antwort ist noch nicht ganz richtig.",
          "max": "Du hast die maximale Anzahl an Antworten überschritten."
        }
      },
      "validation": {
        "max": "Du hast zu viele Antworten ausgewählt."
      }
    },
    "results": {
      "average_score_no_scores": "Du hast Aufgaben gemacht, für die du keine Punktzahl erhältst.",
      "average_score_text": "Bisher hast du eine durchschnittliche Punktzahl von {{score}} bei den erledigten Aufgaben.",
      "average_score_title": "Durchschnittliche Punktzahl",
      "average_score_title_selftest": "Punktzahl: {{score}}",
      "average_score_title_with_score": "Durchschnittliche Punktzahl: {{score}}",
      "back": "Sieh dir alle deine Aufgaben an",
      "legenda": {
        "open_assignment": "Offene Aufgabe",
        "title": "Legende:"
      },
      "loading": "Die Ergebnisse werden geladen...",
      "progress_text": "Du hast {{count}} von {{total}} Aufgaben gemacht.",
      "progress_title": "Dein Fortschritt",
      "progress": {
        "completed": "Du hast dieses Aufgabenblock abgeschlossen mit einer Punktzahl von",
        "completed_no_score": "Du hast dieses Aufgabenblock abgeschlossen.",
        "incomplete": "Du hast noch nicht alle Aufgaben abgeschlossen."
      },
      "questions_title": "Ergebnis pro Aufgabe",
      "questions": {
        "done": "Die Aufgaben sind nach Punktzahl sortiert. Du kannst die Aufgaben mit den niedrigsten Punktzahlen noch einmal ansehen",
        "todo": "Beantworte die folgenden Fragen, um das Aufgabenblock abzuschließen."
      },
      "test_ended": "Eingereicht am {{date}} um {{time}} Uhr.",
      "test_started": "Gestartet am {{date}} um {{time}} Uhr.",
      "title": "Ergebnisse",
      "title_selftest": "Ergebnisse: Selbsttest"
    },
    "score": {
      "message": {
        "excellent": "Tolle Arbeit, mach weiter so!",
        "marginal": "Auf dem richtigen Weg. Übe noch ein bisschen mehr!",
        "poor": "Kein Problem! Lerne aus dem Feedback und versuche es noch einmal.",
        "satisfactory": "Gut gemacht! Das ist eine tolle Punktzahl.",
        "unsatisfactory": "Du kannst es besser! Übe noch ein wenig mehr."
      }
    },
    "sidebar": {
      "back": "Aufgabenübersicht",
      "back-to-theory": "Zur Theorie",
      "nav": {
        "introduction": "Einführung",
        "results": "Ergebnisse"
      },
      "navigation": {
        "aria-label": {
          "close": "Inhaltsverzeichnis schließen",
          "collapse": "Inhaltsverzeichnis einklappen",
          "expand": "Inhaltsverzeichnis erweitern",
          "open": "Inhaltsverzeichnis öffnen"
        }
      },
      "secondary": {
        "nav": {
          "sources": "Referenzen",
          "terms": "Begriffe",
          "theory": "Theorie"
        }
      },
      "tools": {
        "aria-label": {
          "close": "Theorie schließen",
          "material": "{{ material }} öffnet in einem neuen Fenster.",
          "open": "Öffne die Theorie"
        }
      }
    },
    "status": {
      "answered": "Antwort wurde eingereicht",
      "checkingAvailable": "Du kannst jetzt deine Antwort überprüfen",
      "default": "Noch nicht gemacht",
      "disabled": "Verfügbar nach Beginn des Selbsttests",
      "done": "Antwort wurde überprüft",
      "draft": "Antwort wurde noch nicht eingereicht"
    },
    "theory": {
      "alert": {
        "no_assignment_theory_found": "Für diese Aufgaben gibt es keine Theorie."
      },
      "close-theory": "Theorie schließen"
    }
  },
  "button": {
    "adjust": "Anpassen",
    "cancel": "Abbrechen",
    "delete": "Entfernen",
    "save": "Speichern"
  },
  "common": {
    "back_to_top": "Zurück nach oben",
    "next": "Nächster",
    "table_of_contents": "Inhaltsverzeichnis"
  },
  "content": {
    "breadcrumbs": {
      "index": "Inhaltsverzeichnis"
    },
    "figure": {
      "fallback-label": "Quelle {{addition}}"
    },
    "frame": {
      "label": {
        "case": "Kasus",
        "context": "Kontext",
        "dialogue": "Gespräch",
        "example": "Beispiel",
        "explanation": "Erklärung",
        "summary": "Zusammenfassung"
      }
    },
    "interactions": {
      "drawing_canvas": {
        "actions": {
          "clear": "Alles löschen"
        }
      },
      "model_answer": "Musterantwort",
      "self_score": {
        "open_text": {
          "title": "Überprüfe deine Antwort:"
        },
        "rubric_group": {
          "weight": "Bestimmt {{weight}}% der Gesamtpunktzahl."
        },
        "rubric": {
          "completed": "Dies ist die Gesamtpunktzahl, die du dir für diese Aufgabe gegeben hast.",
          "explanation": "Die Punktzahl setzt sich aus den folgenden Komponenten zusammen:",
          "next_group": "Nächste Bewertung",
          "prev_group": "Vorherige Bewertung",
          "title": "Überprüfe deine Antwort selbst und wähle eine passende Punktzahl:"
        },
        "scale": {
          "explanation": "Dies ist die Punktzahl, die du deiner eingereichten Antwort gegeben hast:",
          "title": "Wie genau ist deine Antwort?"
        }
      },
      "speaking": {
        "action_listen": {
          "label": "Hören"
        },
        "action_play": {
          "instruction": "Aufnahme",
          "label": "Abspielen"
        },
        "action_record": {
          "instruction": "Gedrückt halten",
          "label": "Aufnehmen"
        },
        "score": {
          "excellent": "Gut gemacht!",
          "poor": "Das kann besser sein. Hör noch einmal genau auf die Wörter mit einer Unterstreichung darunter.",
          "satisfactory": "Fast richtig, versuche es noch einmal!",
          "unsatisfactory": "Guter Versuch, aber es kann besser werden. Hör noch einmal genau auf die Wörter mit einer Unterstreichung darunter."
        }
      },
      "upload": {
        "drop_dragging_file": "Lassen Sie Ihr Bild los, um es hochzuladen",
        "drop_file": "Lade ein Bild hoch",
        "dropped_file": "Ihre Datei wurde hochgeladen!",
        "placeholder": "Ziehen Sie ein Bild hierher oder wählen Sie ein Bild aus",
        "select_file": "Bild auswählen",
        "uploading": "Bild wird hochgeladen..."
      },
      "validators": {
        "max": "Du hast die maximale Anzahl an Antworten überschritten.",
        "min": "Der Mindestwert ist {{min}}",
        "must-contain": "Ihre Antwort muss '{{mustContain}}' enthalten",
        "required": "Sie müssen eine Antwort angeben"
      },
      "your_answer": "Deine Antwort"
    },
    "quote": {
      "author": {
        "title": "Autor des Zitats"
      }
    },
    "remark": {
      "label": {
        "attention": "Achtung!",
        "hint": "Hinweis",
        "tip": "Tipp"
      }
    },
    "score-label": {
      "completed": "Aufgabe erledigt"
    }
  },
  "label": {
    "theory": "Theorie"
  },
  "landing": {
    "main": {
      "label_all_arrangements": "Alle Unterrichtsmittel",
      "label_continue": "Weiter",
      "label_user_defined_arrangements": "Von deinem Lehrer vorbereitete Unterrichtsmittel"
    },
    "view_all": "Alle Unterrichtsmittel"
  },
  "teacher-material": {
    "articles": {
      "learning_time_indicator": "{{ amount }} Minuten"
    }
  }
}
